const year = (new Date()).getFullYear();
export const TOTAL_VISITS = `${year}_total_visits`;
export const LAST_VISIT = `${year}_last_visit`;



// WEBPACK FOOTER //
// ./src/localstorage/localstorageKeys.js